import { z } from "zod";

export const getLatestMileagePayloadSchema = z.object({
  companyUuid: z.uuid().optional(),
  departmentUuid: z.uuid().optional(),
  date: z.iso.datetime(),
});

export type GetLatestMileagePayload = z.infer<
  typeof getLatestMileagePayloadSchema
>;
